import React, { useEffect, useState } from 'react'
import ProgressBar from './ProgressBar'
import AccountForm from '../../types/account-form.types'
import { Lang } from '../../types/common-types'
import { generateId } from '../../utils/helpers'

import styles from './TopSide.module.scss'
import InfoMessage from '../../shared/InfoMessage/InfoMessage'

interface Props {
  step: number
  totalsteps: number
  accountForm: AccountForm
  lang: Lang
  className?: string
  stepImage?: string
  profileType: any
  showInfoMessage?: boolean
}

const id = generateId(6)

const TopSide: React.FC<Props> = ({
  step,
  totalsteps,
  accountForm,
  lang,
  profileType,
  showInfoMessage
}: Props) => {
  const [currentStep, ofSteps] = accountForm.stepsText[lang].split('%step%')
  const currentStepText = `${currentStep} ${step}`
  const ofStepsText = ofSteps.replace('%steps%', `${totalsteps}`) //'6')
  const stepsText = `${currentStepText} ${ofStepsText}`

  return (
    <div className={styles.TopSide + ' ' + 'row'}>
      {showInfoMessage && <InfoMessage type='default' text={
        lang === 'eng' ? (
          <span>
            <strong>Just one last step!</strong><br />
            Please click the &quot;Submit&quot; button at the bottom of the page to send us your request.<br />
            And a small note: <span className={styles.red}>Right now, you're just sending us your details</span>. The actual equipment booking will happen <span className={styles.red}>after we review your application</span>. After that, your manager will contact you to explain your personalized deposit terms.
          </span>
        ) : lang === 'kz' ? (
          <span>
            <strong>Соңғы қадам қалды!</strong><br />
            Сұранысыңызды бізге жіберу үшін парақтың төменгі жағындағы &quot;Жіберу&quot; түймесін басыңыз.<br />
            Тағы бір нақтылау: <span className={styles.red}>қазір сіз сауалнама деректерін жіберіп жатырсыз</span>. Техниканы брондаудың өзі <span className={styles.red}>сауалнама тексерілгеннен кейін</span> жүзеге асырылады. Сондай-ақ, менеджер сізге жеке кепілдік шарттары туралы толық ақпарат береді.
          </span>
        ) : (
          <span>
            <strong>Остался последний шаг!</strong><br />
            Нажмите на кнопку «Отправить» внизу страницы, чтобы ваш запрос улетел к нам.<br />
            И небольшое уточнение: <span className={styles.red}>сейчас вы отправляете анкетные данные</span>. Само бронирование техники будет осуществляться уже <span className={styles.red}>после проверки анкеты</span>. Также менеджер расскажет всё о ваших персональных залоговых условиях.
          </span>
      )}/>}
      <ProgressBar
        profileType={profileType}
        step={step}
        totalsteps={totalsteps}
        stepsText={stepsText}
        stepsAriaLabel={accountForm.stepsAriaLabel[lang]}
        accountForm={accountForm}
        lang={lang}
      />
    </div>
  )
}

export default TopSide
